module.exports = __webpack_public_path__ + "img/marry-fit-female-6.914ae837.png";